// extracted by mini-css-extract-plugin
export var other_details = "testimonials-module--other_details--e12f9";
export var ptSans = "testimonials-module--ptSans--89b4c";
export var quote_wrap = "testimonials-module--quote_wrap--63941";
export var rating_wrap = "testimonials-module--rating_wrap--1f4bd";
export var sliderLink = "testimonials-module--sliderLink--e6698";
export var testimonial_desc = "testimonials-module--testimonial_desc--2b920";
export var testimonial_swiper = "testimonials-module--testimonial_swiper--e8fb6";
export var testimonials = "testimonials-module--testimonials--aaebd";
export var testimonials_image_wrap = "testimonials-module--testimonials_image_wrap--7749f";
export var testimonials_info = "testimonials-module--testimonials_info--be323";
export var testimonials_listing = "testimonials-module--testimonials_listing--9c28c";
export var testimonials_wrap = "testimonials-module--testimonials_wrap--9a765";
export var user_details_wrap = "testimonials-module--user_details_wrap--23c35";
export var user_info_wrap = "testimonials-module--user_info_wrap--d9459";
export var user_name = "testimonials-module--user_name--79ecd";
export var video_icon = "testimonials-module--video_icon--3d0e9";